import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@workboard/wobo-ui';
import TeamSettingsModal from './components/team-settings/teamSettingsModal';
import { AddMenu, AddMenuProps } from './components/add-menu/add-menu';
import TeamBreadcrumb from './components/breadcrumbs';
import {
  MemberRequestContainer,
  MemberRequestContainerProps,
} from './components/member-requests/member-request-container';
import {
  RequestToJoinButton,
  RequestToJoinProps,
} from './components/request-to-join-button/request-to-join-button';
import {
  BulkTeamSettingsButton,
  BulkTeamSettingsProps,
} from './components/team-settings/bulkTeamSettingsButton';

declare global {
  interface Window {
    teamBreadcrumb: (name: string, teamType: number) => void;
    initTeamSettingMenuItemComp: (
      teamId: number,
      isTeamVisible: string | boolean,
    ) => void;
    initBulkTeamSettingsButton: (
      initialData: BulkTeamSettingsProps,
      container: HTMLElement,
    ) => void;
    initTeamsAddMenu: (
      initialData: AddMenuProps,
      container: HTMLElement,
    ) => void;
    initMemberRequestContainer: (
      initialData: MemberRequestContainerProps,
      container: HTMLElement,
    ) => void;
    initRequestToJoinButton: (
      initialData: RequestToJoinProps,
      container: HTMLElement,
    ) => void;
    openAddEditObjectivePopup: ({ tid }: { tid: number }) => void;
    openCreateWsDialog: (data: never) => void;
    loadTeamPopupBoxes: () => void;
    team_dialog: {
      loadTeamPopupBoxes: () => void;
      html: (data: string) => void;
      dialogInit: () => void;
      dialog: (
        action: string,
        type?: string,
        param?: string | number | Array<number | string>,
      ) => void;
    };
    fnRemoveUserFromTeam: (
      teamId: number,
      memberId: number,
      deleteMyself: number,
      newLanding: boolean,
    ) => void;
  }
}

export const initTeamSettingMenuItem = (
  teamId: number | string,
  isTeamVisible: string | boolean,
): void => {
  const domContainer = document.getElementById('react_teamSettingsModal');

  if (domContainer !== null) {
    const root = createRoot(domContainer);
    root.render(
      <React.StrictMode>
        <ThemeProvider>
          <TeamSettingsModal
            teamId={+teamId}
            isTeamVisible={!!+isTeamVisible}
            onClose={() => root.unmount()}
          />
        </ThemeProvider>
      </React.StrictMode>,
    );
  }
};

const initTeamsAddMenu = (
  initialData: AddMenuProps,
  container: HTMLElement,
): void => {
  createRoot(container).render(
    <ThemeProvider>
      <AddMenu {...initialData} />
    </ThemeProvider>,
  );
};

const initMemberRequestContainer = (
  initialData: MemberRequestContainerProps,
  container: HTMLElement,
): void => {
  createRoot(container).render(
    <ThemeProvider>
      <MemberRequestContainer {...initialData} />
    </ThemeProvider>,
  );
};

const initRequestToJoinButton = (
  initialData: RequestToJoinProps,
  container: HTMLElement,
): void => {
  createRoot(container).render(
    <ThemeProvider>
      <RequestToJoinButton {...initialData} />
    </ThemeProvider>,
  );
};

const initBulkTeamSettingsButton = (
  initialData: BulkTeamSettingsProps,
  container: HTMLElement,
): void => {
  createRoot(container).render(
    <ThemeProvider>
      <BulkTeamSettingsButton {...initialData} />
    </ThemeProvider>,
  );
};

window.initBulkTeamSettingsButton = initBulkTeamSettingsButton;
window.initTeamSettingMenuItemComp = initTeamSettingMenuItem;
window.initTeamsAddMenu = initTeamsAddMenu;
window.initMemberRequestContainer = initMemberRequestContainer;
window.initRequestToJoinButton = initRequestToJoinButton;
window.teamBreadcrumb = TeamBreadcrumb;
